<template>
    <div :class="['app-auth-page', 'reg-bg']">
        <div id="components-section">
            <router-view data-aos="fade-left"></router-view>
        </div>

        <div
            class="welcomeMsg"
            v-if="user_name && $route.name == 'sign-in-password'"
        >
            <h1>
                <span class="msg">{{ $t("Welcome back,") }}</span>
                <span class="name">{{ user_name }}</span>
            </h1>
        </div>
    </div>
</template>

<script>
// :class="['app-auth-page', `login-bg-${img}`]"
export default {
    data() {
        return {
            img: 1,
        };
    },
    computed: {
        user_name() {
            return this.$store.getters.user_name;
        },
    },
    created() {
        this.img = Math.floor(Math.random() * 3 + 1);
    },
};
</script>

<style lang="scss" scoped>
.welcomeMsg {
    position: absolute;
    right: 3em;
    top: 2em;
    font-size: 32px;
    color: white;
    display: flex;
    align-items: center;

    .msg {
        font-size: 40px;
        opacity: 0.6;
    }

    .name {
        font-size: 45px;
        margin: 0 10px;
    }
}

.app-auth-page {
    // background: no-repeat 0 50%;
    min-height: 111vh;
    overflow: hidden;

    min-width: 100vw;
    // background-size: cover;
    // min-height: 100vh;
    display: flex;
    justify-content: flex-end;
    padding: 10px 30px;
    position: relative;

    @media screen and (max-width: 600px) {
        padding: 3px !important;
    }

    #components-section {
        width: 540px;

        @media screen and (max-width: 600px) {
            width: 100%;
        }

        z-index: 999999;
    }

    h2 {
        text-align: center;
        font-size: 26px;
        color: #777;
        padding: 15px;
        width: 35%;
    }

    #white-section {
        background-color: white;
        min-width: 500px;
        width: 200vw;
        height: 250px;
        transform: rotate(3deg);
    }

    .banner {
        width: 414px;
        height: 200px;
        display: inline-block;
        transform: rotate(-3deg);
    }

    .image {
        width: 414px;
        margin-top: 50px;
        margin-left: calc(25% - 207px);
    }
}
</style>
